module.exports = __webpack_public_path__ + "img/制御工学2_5.b14787f3.png";